import { paths, type ConfigIssue } from '@acs/shared';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase.js';

/**
 * The server's verdict on this business's configuration (doc 33 W9 #9–10):
 * written by the publisher after every settings write. `ok: false` means the
 * last save was NOT published and calls still run on the previous version.
 */
export interface Readiness {
  ok: boolean;
  issues: ConfigIssue[];
  publishedVersion: string | null;
}

export function subscribeReadiness(businessId: string, cb: (r: Readiness | null) => void): () => void {
  return onSnapshot(
    doc(db, paths.configReadiness(businessId)),
    (snap) => cb(snap.exists() ? (snap.data() as Readiness) : null),
    () => cb(null),
  );
}
